export default __webpack_public_path__ + "static/media/home-decor-img-06.d78d9551.jpg";